export const adminValidationConfig = {
    columns:[
        {headerName:"WD Code",mappedValue:"referenceId",width:200,headerAlign:"left",align:"left"},
        {headerName:"Request ID",mappedValue:"id",width:450,headerAlign:"left",align:"left"},
        {headerName:"Request Time",mappedValue:"creationTime",width:250,headerAlign:"left",align:"left"},
        {headerName:"Status",mappedValue:"status",width:200,headerAlign:"center",align:"center"},
        ],
    Actions:[
        "update"
    ]
}